module.exports = __webpack_public_path__ + "img/city-detroit.abd08dea.png";